// src/components/quality/charts/AssessmentsCountByOperatorChart.js
import { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const AssessmentsCountByOperatorChart = ({ assessments, fieldOptions }) => {
  const [chartData, setChartData] = useState({});

  useEffect(() => {
    if (!assessments || !fieldOptions) return;

    // Группируем оценки по операторам
    const byOperators = {};

    // Получаем список операторов
    const operators = fieldOptions.operators || [];

    // Инициализируем данные для всех операторов
    operators.forEach(operator => {
      const operatorName = `${operator.surname} ${operator.name}`;
      byOperators[operatorName] = {
        id: operator.id,
        name: operatorName,
        count: 0
      };
    });

    // Подсчитываем количество оценок для каждого оператора
    assessments.forEach(assessment => {
      const agentName = assessment.agent_name;
      if (agentName && byOperators[agentName]) {
        byOperators[agentName].count++;
      }
    });

    // Преобразуем объект в массив и сортируем по количеству оценок
    const data = Object.values(byOperators)
      .filter(item => item.count > 0)
      .sort((a, b) => b.count - a.count);

    // Подготавливаем данные для Chart.js
    setChartData({
      labels: data.map(item => item.name),
      datasets: [
        {
          label: 'Количество проверок',
          data: data.map(item => item.count),
          backgroundColor: 'rgba(53, 162, 235, 0.5)',
          borderColor: 'rgba(53, 162, 235, 1)',
          borderWidth: 1,
          borderRadius: 4
        }
      ]
    });
  }, [assessments, fieldOptions]);

  const options = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      title: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            return `Количество: ${context.raw}`;
          }
        }
      },
      datalabels: {
        anchor: 'center',
        align: 'right',
        color: '#333',
        font: {
          weight: 'bold',
          size: 14
        },
        formatter: (value) => value,
        offset: 4,
        display: true
      }
    },
    scales: {
      y: {
        beginAtZero: false,
        grid: {
          display: true
        },
        ticks: {
          font: {
            size: 14
          },
          color: '#333'
        }
      },
      x: {
        beginAtZero: true,
        grid: {
          display: true
        },
        ticks: {
          font: {
            size: 14
          },
          color: '#666',
          stepSize: 1,
          precision: 0
        },
        title: {
          display: true,
          text: 'Количество оценок',
          font: {
            size: 16,
            weight: 'bold'
          },
          color: '#666'
        }
      }
    }
  };

  return (
    <div className="chart-card">
      <h3>Количество проверок по операторам</h3>
      {Object.keys(chartData).length === 0 ? (
        <div className="no-data">Нет данных для отображения</div>
      ) : (
        <div className="chart-container" style={{ padding: '20px', height: '600px', overflow: 'auto' }}>
          <Bar data={chartData} options={options} />
        </div>
      )}
    </div>
  );
};

export default AssessmentsCountByOperatorChart;